import React, {useState} from "react";
import {Box, Button, Card, CardActions, CardContent, CardHeader, Stack, TextField, Typography} from "@mui/material";

import {useTranslation} from "react-i18next";
import {useLocation, useSearchParams} from "wouter";

import {authClient} from "./App.jsx";
import PasswordField from "./PasswordField";

export const ChangePassword = () => {
    const [location, setLocation] = useLocation();
    const {t} = useTranslation();

    const handleSubmit = async ({newPassword, currentPassword}) => {
        const {data, error} = await authClient.changePassword({newPassword, currentPassword});
        }

    const handleCancel = () => {
        setLocation("/");
        }

    return <PasswordForm title={t("Change Password")} onSubmit={handleSubmit} onCancel={handleCancel}/>;
    }

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const {t} = useTranslation();

    const handleSubmit = async ({newPassword}) => {
        const token = searchParams.get("token");
        const {data, error} = await authClient.resetPassword({newPassword, token});
        }

    const handleCancel = () => {
        window.close();
        }

    return <PassswordForm title={t("Reset Password")} withCurrent={false} onSubmit={handleSubmit} onCancel={handleCancel}/>;
    }

const PasswordForm = ({title, withCurrent=true, onSubmit, onCancel}) => {
    const {t} = useTranslation();

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");

    const [message, setMessage] = useState("");

    const handleChange = (event) => {
        const {name, value} = event.target;
        switch (name) {
            case "currentPassword": setCurrentPassword(value); break;
            case "newPassword": setNewPassword(value); break;
            }
        }

    const handleSubmit = async (event) => {
        event.preventDefault();
        await onSubmit({currentPassword, newPassword});
        }

    return <CardContent sx={{ p: 4 }}>
                <Typography variant="h5" gutterBottom fontWeight="bold">{title}</Typography>
                {withCurrent &&
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        {t('To secure your account, please enter your current password first.')}
                    </Typography>
                    }

                <Box component="form" onSubmit={handleSubmit }>
                    <Stack spacing={2}>
                        {withCurrent &&
                            <PasswordField name="currentPassword" value={currentPassword} label={t('Current Password')} onChange={handleChange}/>
                            }
                        <PasswordField name="newPassword" value={newPassword} label={t('New Password')} onChange={handleChange}/>

                        <Button type="submit" fullWidth variant="contained" size="large">{t('Update Password')}</Button>
                        <Button onClick={onCancel} fullWidth color="inherit">{t('Cancel')}</Button>
                    </Stack>
                </Box>
            </CardContent>;
    }

export default ResetPassword;